import isNil from 'lodash/isNil';
import { hasAnyIdentificationFieldValue } from '../../utils/validators';
import {
  validateSocialSecurityNumber,
  validateAlphaNumericValue,
  validateDriverLicenseNumber,
} from '../../../../utils/validations';

const RegistrationAndLegal = {
  name: 'registrationAndLegal',
  title: 'REGISTRATION AND LEGAL',
  titleVariant: 'subsection',
  container: 'default',
  caption:
    '** You must provide at least one of the following: Driver License/State ID (if so, select a State), ' +
    'Social Security Number or Taxpayer Identification Number, Passport (if so, select a Country), ' +
    'or Alien Registration Number. If you have a Social Security Number, you must provide it.',
  fields: [
    {
      variant: 'text',
      name: 'driversLicenseStateId',
      label: 'Driver License / State ID',
      rules: {
        // required: ({ getValues }) => !hasAnyIdentificationFieldValue(getValues),
        validate: (value, getValues) => {
          if (value && !validateDriverLicenseNumber(value)) {
            return 'Invalid value';
          }
          return hasAnyIdentificationFieldValue(getValues)
            ? true
            : 'Driver License / State ID is required';
        },
      },
      watchFields: ['driversLicenseStateId', 'ssnOrTin', 'passportNumber'],
      GridProps: { xs: 12, sm: 3 },
    },
    {
      variant: 'singleSelect',
      name: 'driversLicenseIdState',
      label: 'Driver License / ID State',
      placeholder: 'Select',
      rules: {
        required: true,
      },
      watchFields: ['driversLicenseStateId'],
      hidden: ({ getValues }) => {
        const driversLicenseStateId = getValues('driversLicenseStateId');
        return isNil(driversLicenseStateId) || driversLicenseStateId === '';
      },
      GridProps: { xs: 12, sm: 3 },
    },
    {
      // currently ssn variant has issues with the encrypted values
      variant: 'text',
      name: 'ssnOrTin',
      label: 'Social Security Number / TIN',
      placeholder: 'XXX-XX-XXXX',
      rules: {
        // required: ({ getValues }) => !hasAnyIdentificationFieldValue(getValues),
        validate: (value, getValues) => {
          if (value) {
            if (!validateSocialSecurityNumber(value)) {
              return 'Invalid Social Security Number';
            }
          }
          return hasAnyIdentificationFieldValue(getValues)
            ? true
            : 'Social Security Number / TIN is required';
        },
      },
      watchFields: ['driversLicenseStateId', 'ssnOrTin', 'passportNumber'],
      GridProps: { xs: 12, sm: 3 },
    },
    {
      variant: 'flexSpacer',
    },
    {
      variant: 'text',
      name: 'passportNumber',
      label: 'Passport Number',
      rules: {
        // required: ({ getValues }) => !hasAnyIdentificationFieldValue(getValues),
        maxLength: 20,
        validate: (value, getValues) => {
          if (value && !validateAlphaNumericValue(value)) {
            return 'Invalid value';
          }
          return hasAnyIdentificationFieldValue(getValues)
            ? true
            : 'Passport Number is required';
        },
      },
      watchFields: ['driversLicenseStateId', 'ssnOrTin', 'passportNumber'],
      GridProps: { xs: 12, sm: 3 },
    },
    {
      variant: 'singleSelect',
      name: 'passportCountry',
      label: 'Passport Country',
      placeholder: 'Select',
      rules: {
        required: true,
      },
      watchFields: ['passportNumber'],
      hidden: ({ getValues }) => {
        const passportNumber = getValues('passportNumber');
        return isNil(passportNumber) || passportNumber === '';
      },
      GridProps: { xs: 12, sm: 3 },
    },
    {
      variant: 'text',
      name: 'alienRegistrationNumber',
      label: 'Alien Registration Number (If no SSN)',
      rules: {
        validate: (value) => {
          if (value) {
            if (!validateAlphaNumericValue(value)) {
              return 'Invalid value';
            }
          }
          return true;
        },
      },
      GridProps: { xs: 12, sm: 3 },
    },
  ],
};

export default RegistrationAndLegal;
